import { render, staticRenderFns } from "./ChallengeRules.vue?vue&type=template&id=5f007ab8&"
import script from "./ChallengeRules.vue?vue&type=script&lang=ts&"
export * from "./ChallengeRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports